import React, { PureComponent } from 'react';

import * as categoryTrans from '../translations/category_trans';
import * as generalTrans from '../translations/general_trans';

export default class InterestStep extends PureComponent {
  constructor(props) {
    super(props);
    this.handleData = this.handleData.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.state = {
      data: {
        id: '',
        title: '',
        interests: [],
        types: [],
      },
      cTrans: window.location.href.includes('.at')
        ? categoryTrans.at
        : categoryTrans[window.campaign_data.common_translations.language],
      gTrans: window.location.href.includes('.at')
        ? generalTrans.at
        : generalTrans[window.campaign_data.common_translations.language],
    };
  }

  handleData(value, checked, type) {
    const list = this.state.data.interests;
    const types = [...this.state.data.types];
    if (checked) {
      list.push(value);
      types.push(type);
    } else if (list.includes(value)) {
      const index = list.indexOf(value);
      list.splice(index, 1);
      types.splice(index, 1);
    }
    this.setState((prevState) => {
      const oldData = { ...prevState.data };
      oldData.interests = list;
      oldData.types = types;
      return {
        data: oldData,
      };
    });
  }

  handleNext() {
    this.setState((prevState) => {
      const oldData = prevState.data;
      oldData.id = prevState.cTrans.category_id;
      oldData.title = prevState.cTrans.category;
      const data = [];
      data.push(oldData);
      this.props.onNextClick(data);
      return {
        data: oldData,
      };
    });
  }
  // handleNext() {
  //   const oldData = this.state.data;
  //   oldData.id = this.state.cTrans.category_id;
  //   oldData.title = this.state.cTrans.category;
  //   this.setState({
  //     data: oldData,
  //   });

  //   const data = [];
  //   data.push(this.state.data);
  //   this.props.onNextClick(data);
  //   console.log(data);
  // }

  interestClick(num, type) {
    const arr = [this.input1, this.input2, this.input3, this.input4];
    if (arr[num].checked) {
      arr[num].checked = false;
    } else {
      arr[num].checked = true;
    }
    // arr[num].checked ? arr[num].checked = false : arr[num].checked = true;
    this.handleData(arr[num].value, arr[num].checked, type);
  }

  render() {
    const { cTrans } = this.state;
    const { gTrans } = this.state;
    return (
      <section
        className="interest-section"
      >
        <h4 className="categoryTitle" style={{ color: this.props.titleColor }}>
          {gTrans.headlineStep2}
        </h4>
        {/* <p className="categoryTitle">{cTrans.category}</p> */}
        <div className="interests">
          <div className="container container1">
            <input
              className="checkbox"
              type="checkbox"
              name="boot"
              value={cTrans.boot_id}
              id="terms"
              onChange={event => this.handleData(event.target.value, event.target.checked, 'boots')
              }
              ref={(input1) => {
                this.input1 = input1;
              }}
            />
            <span className="checkmark"> </span>
            <p
              onClick={() => this.interestClick(0, 'boots')}
              style={{ color: this.props.textColor, outline: 'none' }}
              role="button"
              tabIndex="0"
            >
              {' '}
              {cTrans.boot}
              {' '}
            </p>
          </div>
          <div className="container container2">
            <input
              className="checkbox"
              type="checkbox"
              name="shirts"
              value={cTrans.shirt_id}
              id="terms"
              onChange={event => this.handleData(event.target.value, event.target.checked, 'shirts')
              }
              ref={(input2) => {
                this.input2 = input2;
              }}
            />
            <span className="checkmark"> </span>
            <p
              onClick={() => this.interestClick(1, 'shirts')}
              style={{ color: this.props.textColor, outline: 'none' }}
              role="button"
              tabIndex="0"
            >
              {' '}
              {cTrans.shirt}
              {' '}
            </p>
          </div>

          <div className="container container3">
            <input
              className="checkbox"
              type="checkbox"
              name="goalkeeper"
              value={cTrans.goalkeeper_id}
              id="terms"
              onChange={event => this.handleData(event.target.value, event.target.checked, 'goalkeeper')
              }
              ref={(input3) => {
                this.input3 = input3;
              }}
            />
            <span className="checkmark"> </span>
            <p
              onClick={() => this.interestClick(2, 'goalkeeper')}
              style={{ color: this.props.textColor, outline: 'none' }}
              role="button"
              tabIndex="0"
            >
              {' '}
              {cTrans.goalkeeper}
              {' '}
            </p>
          </div>
          <div className="container container4">
            <input
              className="checkbox"
              type="checkbox"
              name="kids"
              value={cTrans.kids_id}
              id="terms"
              onChange={event => this.handleData(event.target.value, event.target.checked, 'kids')
              }
              ref={(input4) => {
                this.input4 = input4;
              }}
            />
            <span className="checkmark"> </span>
            <p
              onClick={() => this.interestClick(3, 'kids')}
              style={{ color: this.props.textColor, outline: 'none' }}
              role="button"
              tabIndex="0"
            >
              {' '}
              {cTrans.kids}
              {' '}
            </p>
          </div>
        </div>
        <div className="continue">
          <button
            type="button"
            className={`signup ${this.props.roundTheCorners}`}
            style={{
              backgroundColor: this.props.ctaBackgroundColor,
              color: this.props.ctaTextColor,
              borderBottomColor: this.props.ctaBorderColor,
            }}
            onClick={() => this.handleNext()}
          >
            {gTrans.ctaNext}
          </button>
        </div>
      </section>
    );
  }
}
